import { j as f } from "../../../jsx-runtime-82a9ddf6.js";
import { c as n } from "../../../clsx-0c6e471a.js";
import "react";
const d = (i) => {
  const {
    className: v,
    variant: t = "default",
    size: o = "medium",
    disabled: r,
    component: e = "button",
    rounded: b = !1,
    ...a
  } = i;
  return /* @__PURE__ */ f.jsx(
    e,
    {
      className: n(
        "fbv2-transition-colors hover:fbv2-opacity-75",
        {
          "fbv2-px-4 fbv2-py-2.5": o === "small" && t !== "link",
          "fbv2-px-7 fbv2-py-3.5": o === "medium" && t !== "link"
        },
        {
          "fbv2-border fbv2-bg-white fbv2-text-primary hover:fbv2-bg-primary-light": t === "default",
          "fbv2-bg-primary fbv2-text-white hover:fbv2-opacity-90": t === "primary",
          "fbv2-bg-secondary fbv2-text-white hover:fbv2-opacity-90": t === "secondary"
        },
        {
          "fbv2-cursor-not-allowed fbv2-opacity-50": r
        },
        {
          "fbv2-rounded-md": !b,
          "fbv2-rounded-[50px]": b
        },
        v
      ),
      type: e === "button" ? "button" : void 0,
      disabled: r,
      ...a
    }
  );
};
export {
  d as Button
};
